// import configure from "./configure"
// export default configure

import configure from "./configure"
export default configure()
